import { ContentHubFeedList } from "./components/ContentHubFeedList";
import { CONTENT_HUB_SOURCES } from "./config";
import { useContentHubStreamStatus } from "./hooks";
import type { ContentHubStreamStatus } from "./types";

const STATUS_META: Record<
  ContentHubStreamStatus,
  { label: string; dotClass: string }
> = {
  idle: { label: "Idle", dotClass: "bg-gray-400" },
  connecting: { label: "Connecting…", dotClass: "bg-amber-500 animate-pulse" },
  connected: { label: "Live", dotClass: "bg-green-500" },
  reconnecting: {
    label: "Reconnecting…",
    dotClass: "bg-amber-500 animate-pulse",
  },
};

function StreamStatusIndicator() {
  const status = useContentHubStreamStatus();
  const { label, dotClass } = STATUS_META[status];
  return (
    <span className="flex items-center gap-1.5 text-xs text-gray-600 dark:text-gray-300">
      <span className={`h-2 w-2 rounded-full ${dotClass}`} />
      {label}
    </span>
  );
}

/**
 * New content-hub views, mounted alongside the legacy headline/truth-social
 * screens (which stay untouched) so the old and new paths can be compared.
 * Both lists share one /v1/stream SSE connection.
 */
function ContentHubPage() {
  return (
    <div className="h-screen flex flex-col p-2 gap-2">
      <header className="flex items-center justify-between px-1">
        <h1 className="text-base font-semibold text-gray-900 dark:text-gray-100">
          Content Hub
        </h1>
        <StreamStatusIndicator />
      </header>
      <div className="flex-1 min-h-0 grid grid-cols-1 md:grid-cols-2 gap-2">
        <ContentHubFeedList
          source={CONTENT_HUB_SOURCES.HEADLINES}
          title="Headlines"
        />
        <ContentHubFeedList
          source={CONTENT_HUB_SOURCES.TRUTH_SOCIAL}
          title="Truth Social"
        />
      </div>
    </div>
  );
}

export default ContentHubPage;
